<!--
  Map builder container view for admin screens.
  @author crm4f 
-->

<template>
  
  <div>
    <Logo/>
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link" aria-current="page" style="cursor: pointer;" :class="{'active': active=='Building'}" @click="active='Building'">Buildings</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" aria-current="page" style="cursor: pointer;" :class="{'active': active=='Room'}" @click="active='Room'">Rooms</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" aria-current="page" style="cursor: pointer;" :class="{'active': active=='Route'}" @click="active='Route'">Routes</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" aria-current="page" style="cursor: pointer;" :class="{'active': active=='Feature'}" @click="active='Feature'">Features</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" aria-current="page" style="cursor: pointer;" :class="{'active': active=='Alias'}" @click="active='Alias'">Aliases</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" aria-current="page" style="cursor: pointer;" :class="{'active': active=='Publication'}" @click="active='Publication'">Publication</a>
      </li>
    </ul>
  </div>

  <Building v-if="active=='Building'"/>
  <Room v-if="active=='Room'" />
  <Route v-if="active=='Route'"/>
  <Feature v-if="active=='Feature'"/>
  <Alias v-if="active=='Alias'"/>
  <Publication v-if="active=='Publication'"/>
</template>

<script setup>
import { ref } from 'vue'
import Building from '../components/admin/Building.vue'
import Room from '../components/admin/Room.vue'
import Route from '../components/admin/Route.vue'
import Feature from '../components/admin/Feature.vue'
import Alias from '../components/admin/Alias.vue'
import Publication from '../components/admin/Publication.vue'
import Logo from '../components/Logo.vue'

const active = ref('Building')

</script>